import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useRef } from "react";
import { INSTITUTION_ASSETS } from "../../../../s3-assets/Institution";
import theme from "../theme/theme1";


const SuccessStories = () => {
  const containerRef = useRef(null);
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      x: ["0%", "-100%"],
      transition: {
        duration: 15,
        ease: "linear",
        repeat: Infinity,
      },
    });
  }, [controls]);

  // Array of success stories with unique images and descriptions
  const successStories = [
    {
      id: 1,
      image: INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_1,
      name: "Vaishnavi Prabhakar",
      description: `Hello, I'm Vaishnavi Prabhakar. I secured AIR 3 in JEE Advanced 2024, a dream I've nurtured since the 8th grade. Thanks to Narayana and the support I received from the nLearn app, I was able to turn my dream into a reality. The app played a crucial role in helping me stay focused and organized throughout my preparation journey.`,
      course: "JEE Adv 2024",
    },
    {
      id: 2,
      image: INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_2,
      name: "Arul Balaji",
      description: `I'm Arul Balaji, and I scored 599/600 in NEET. This accomplishment is the result of consistent hard work and the guidance I received. The study resources and support I got, including the nLearn app, were instrumental in helping me achieve my goal of securing a top rank in NEET.`,
      course: "Neet 599/600",
    },
    {
      id: 3,
      image: INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_3,

      name: "Roshini K",
      description: `I'm Roshini K, and I scored 499/500 in my SSLC exams, with a centum in Biology. It was a challenging yet fulfilling journey, and the platform's resources and guidance played a crucial role in my success. With consistent effort and the right support, I was able to achieve outstanding results.`,
      course: "SSlC centum in biology ",
    },
    {
      id: 4,
      image: INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_4,

      name: "Gowtham R",
      description: `I'm Gowtham R, and I scored 598/600 in my HSC exams. My journey was challenging, but with the right guidance and resources, I was able to perform exceptionally well. The platform provided me with invaluable support, helping me stay on track and achieve my academic goals.`,
      course: "HSC598/600",
    },
    {
      id: 5,
      image: INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_5,

      name: "Priya Ganesh",
      description: `I'm Priya Ganesh, and I became the SSLC topper. The journey to this achievement wasn't easy, but with consistent effort and the support of the platform, I was able to excel. The resources and guidance I received played a significant role in helping me reach my goal and perform to the best of my abilities.`,
      course: "SSLC Topper",
    },
  ];

  const extendedStories = [...successStories, ...successStories];

  return (
    <section
      className="p-8 min-h-screen"
      style={{
        backgroundColor: theme.SuccessStories.backgroundColor,
        fontFamily: theme.SuccessStories.fontFamily,
      }}
    >
      <h2
        className="text-4xl font-extrabold text-center mb-12"
        style={{ color: theme.SuccessStories.textColor }}
      >
        Success Stories
      </h2>
      <div ref={containerRef} className="overflow-hidden">
        <motion.div
          className="flex gap-8"
          animate={controls}
          onHoverStart={() => controls.stop()}
          onHoverEnd={() =>
            controls.start({
              x: ["0%", "-100%"],
              transition: {
                duration: 15,
                ease: "linear",
                repeat: Infinity,
              },
            })
          }
        >
          {extendedStories.map((story) => (
            <motion.div
              key={story.id}
              className="flex-shrink-0 w-80 bg-white p-6 shadow-lg transition-transform transform hover:scale-105 overflow-hidden"
              style={{
                fontFamily: theme.SuccessStories.fontFamily,
                borderRadius: "0",
              }}
            >
              <div className="relative group overflow-hidden w-full h-48 mb-4">
                <img
                  src={story.image}
                  alt={story.name}
                  className="w-full h-full object-cover transition-transform transform group-hover:scale-110 duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black opacity-50 group-hover:opacity-30 transition-opacity duration-500"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <h3 className="text-lg font-semibold">{story.course}</h3>
                </div>
              </div>

              <h3
                className="text-xl font-semibold text-center mt-2 mb-2"
                style={{ color: "black" }}
              >
                {story.name}
              </h3>
              <p
                className="text-black text-center mb-4"
                style={{ fontFamily: theme.SuccessStories.fontFamily }}
              >
                {story.description}
              </p>

              <div className="text-center">
                <button className="px-4 py-2 bg-[#a4925a] text-white font-semibold border border-[#a4925a] rounded transition duration-300">
                  Read More &raquo;
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SuccessStories;
